<button class="main" type="text">
  <img src="../../../assets/icons/download_white.png " alt="View Chemical Structure" />
  {{ buttonText }}
</button>
